import { useGetDealTrackerDataQuery } from "../../store/apiSlices/dealTracker";
import { CheckIcon, SpinnerIcon } from "../Icons";

export default function SaveStatus() {
  const { isFetching } = useGetDealTrackerDataQuery();

  return (
    <div>
      {isFetching ? (
        <SpinnerIcon className="size-4 text-gray-200 animate-spin fill-blue-600" />
      ) : (
        <CheckIcon className="size-3 text-green-600" />
      )}
    </div>
  );
}
